module.exports = __webpack_public_path__ + "img/t-shirt-3.e45bc463.png";